import React, {FC} from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import Select, {createFilter} from 'react-select'
type InputProps = {
  data?: any[]
  name: string
  style?: any
  onChangeValue?: (e: any) => void
  disabled?: boolean
  getOptionLabel?: (option: any) => string
}
const customStyles = {
  control: (provided: any) => ({
    ...provided,
    minWidth: '200px',
  }),
  menuPortal: (provided: any) => ({
    ...provided,
    zIndex: 9999, // Asegura que el menú esté por encima de otros elementos
  }),
}
const SelectComponent: FC<InputProps> = ({
  name,
  data = [],
  disabled,
  onChangeValue,
  style,
  getOptionLabel,
  ...props
}) => {
  const {
    control,
    formState: {errors},
  } = useFormContext()
  return (
    <div className='sdx_form_input '>
      <Controller
        control={control}
        name={name}
        render={({field}) => (
          <Select
            {...field}
            key={field.value}
            className='react-select-container'
            classNamePrefix='react-select'
            options={data}
            noOptionsMessage={() => 'No hay resultados'}
            menuPortalTarget={document.body}
            placeholder='Selecciona una opción'
            styles={{...style, ...customStyles}}
            value={data?.find((c: {value: string}) => c.value === field.value)}
            onChange={(val) => {
              field.onChange(val ? val.value : '')
              if (onChangeValue) onChangeValue(val)
            }}
            isDisabled={disabled}
            getOptionLabel={getOptionLabel}
            filterOption={(option, inputValue) =>
    option.label.toLowerCase().includes(inputValue.toLowerCase())
  }
          />
        )}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default SelectComponent
